<template lang="pug">
v-dialog(
  v-model="popupDialog"
  transition="dialog-bottom-transition"
  width="30%"
  )
  v-card
    v-toolbar(dense flat color="accent white--text")
      v-toolbar-title() {{title}}
      v-spacer
      v-btn(icon @click.native="popupDialog = false" dark)
        v-icon close
    v-card-text
      span {{message}}
    v-divider
    v-card-actions
      v-spacer
      v-btn(flat @click.native="popupDialog = false").button CLOSE
</template>

<script>
import Base from '../views/Base';

export default {
    name: 'CheckForUpdatesMessageDialog',
    extends: Base,

    props: {
        showDialog: { type: Boolean, required: true, default: false },
        message: { type: String, required: true },
        title: { type: String, required: true },
    },

    data() {
        return {
            popupDialog: false,
        };
    },

    watch: {
        showDialog(value) {
            if (value) {
                this.popupDialog = true;
            }
        },

        popupDialog(value) {
            if (!value) {
                this.$emit('closed');
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/content/CheckForUpdatesMessageDialog.vue